import { render, staticRenderFns } from "./TaskSupplierAssignments.vue?vue&type=template&id=a9539126&"
import script from "./TaskSupplierAssignments.vue?vue&type=script&lang=js&"
export * from "./TaskSupplierAssignments.vue?vue&type=script&lang=js&"
import style0 from "./TaskSupplierAssignments.vue?vue&type=style&index=0&id=a9539126&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports